var map = {
	"./S10.svg": "e30e",
	"./alcool.svg": "458a",
	"./ar.svg": "6dc9",
	"./br.svg": "3e89",
	"./diesel.svg": "76d7",
	"./gas.svg": "4660",
	"./gasnatural.svg": "bbd9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "65c6";